import React, { Component } from 'react';
import { number, object, shape, string } from 'prop-types';

/**
 * DynamicGoogleMap shows a Google Map with a 3-mile radius circle
 * around a specified center location.
 */
class DynamicGoogleMap extends Component {
  constructor(props) {
    super(props);
    this.map = null;
    this.mapContainer = null;

    this.initializeMap = this.initializeMap.bind(this);
  }

  componentDidMount() {
    if (!this.map && this.mapContainer) {
      this.initializeMap();
    }
  }

  initializeMap() {
    const { offsetHeight, offsetWidth } = this.mapContainer;
    const hasDimensions = offsetHeight > 0 && offsetWidth > 0;

    if (hasDimensions) {
      const { center, zoom } = this.props;
      const maps = window.google.maps;
      const controlPosition = maps.ControlPosition.LEFT_TOP;

      const mapConfig = {
        center,
        zoom,
        mapTypeControl: false,
        scrollwheel: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControlOptions: {
          position: controlPosition,
        },
      };

      // Initialize map
      this.map = new maps.Map(this.mapContainer, mapConfig);

      // Add a 3-mile radius circle (3 miles = 4828.03 meters)
      const circle = new maps.Circle({
        strokeColor: '#FF0000',
        strokeOpacity: 0.6,
        strokeWeight: 1,
        fillColor: '#FF0000',
        fillOpacity: 0.2,
        map: this.map,
        center,
        radius: 4828.03,
      });

      // Adjust map bounds to fit the full circle
      const bounds = circle.getBounds();
      this.map.fitBounds(bounds);
    }
  }

  render() {
    const { containerClassName, mapClassName } = this.props;
    return (
      <div className={containerClassName}>
        <div className={mapClassName} ref={el => (this.mapContainer = el)} />
      </div>
    );
  }
}

DynamicGoogleMap.defaultProps = {
  address: '',
  center: null,
};

DynamicGoogleMap.propTypes = {
  address: string,
  center: shape({
    lat: number.isRequired,
    lng: number.isRequired,
  }).isRequired,
  zoom: number, // starting zoom (auto-adjusts later)
  mapsConfig: object, // kept for backward compatibility
  containerClassName: string,
  mapClassName: string,
};

export default DynamicGoogleMap;
